<template>
  <div
    class="page_container sttingPage"
    v-loading="loading"
    element-loading-text="请稍后"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/manage' }"
          >SKU管理</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/warehousIndex/wManageIndex' }"
          >入库管理</el-breadcrumb-item
        >
        <el-breadcrumb-item
          :to="{
            path: `/warehousIndex/wManageSettingList/${keyword}/${formData.cmid}`,
          }"
          >明细数据</el-breadcrumb-item
        >
        <el-breadcrumb-item>入库管理设置</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="form_container">
      <h1>入库管理设置</h1>
      <div class="content_wrap flex-between">
        <div class="form_wrap">
          <div class="block">
            <p><span class="mark">*</span>入库数量：</p>
            <div class="input_box">
              <el-input
                type="number"
                v-model="formData.num"
                placeholder="输入入库数量"
                maxlength="10"
              ></el-input>
            </div>
          </div>
          <div class="block">
            <p><span class="mark">*</span>入库订单信息记录：</p>
            <div class="input_box">
              <el-input
                type="number"
                v-model="formData.purchaseno"
                placeholder="输入入库订单信息"
                maxlength="50"
              ></el-input>
            </div>
          </div>
          <div class="block">
            <p><span class="mark">*</span>入库收货物流类型：</p>
            <div class="select_box">
              <el-select
                v-model="formData.wsid"
                placeholder="选择记录入库收货物流类型"
                @focus="handleFocusGetLog"
                :loading="loadingLog"
              >
                <el-option
                  v-for="item in logisiticsList"
                  :key="item.etext"
                  :label="item.evalue"
                  :value="item.etext"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="block">
            <p><span class="mark">*</span>入库收货物流单号记录：</p>
            <div class="input_box">
              <el-input
                v-model="formData.wsno"
                placeholder="选择记录入库收货物流单号"
                maxlength="50"
              ></el-input>
            </div>
          </div>
          <div class="block">
            <p><span class="mark">*</span>备注信息记录：</p>
            <div class="textarea_box">
              <el-input
                type="textarea"
                v-model="formData.reason"
                placeholder="填写备注（200字以内）"
                maxlength="200"
              ></el-input>
            </div>
          </div>
          <div class="block">
            <p><span class="mark">*</span>入库位置：</p>
            <div class="select_box">
              <el-select
                v-model="formData.whid1"
                placeholder="选择仓库"
                @change="handleChangeWarehouseOne"
              >
                <el-option
                  v-for="item in warehouseOne"
                  :key="item.value"
                  :label="item.text"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <div class="select_box">
              <el-select
                v-model="formData.whid2"
                placeholder="选择层号"
                @change="handleChangeWarehouseTwo"
              >
                <el-option
                  v-for="item in warehouseTwo"
                  :key="item.value"
                  :label="item.text"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <div class="select_box">
              <el-select
                v-model="formData.whid3"
                placeholder="选择位置"
                @change="handleChangeWarehouseThree"
              >
                <el-option
                  v-for="item in warehouseThree"
                  :key="item.value"
                  :label="item.text"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <div class="select_box">
              <el-select v-model="formData.whid4" placeholder="选择位置">
                <el-option
                  v-for="item in warehouseFour"
                  :key="item.value"
                  :label="item.text"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="block">
            <p><span class="mark">*</span>入库商品属性参数记录：</p>
            <div class="select_box">
              <el-select
                v-model="formData.ams_shop_commodity_attrid"
                placeholder="选择属性标签"
                @focus="handleFocusGetAttrid"
                :loading="loadingAttrid"
              >
                <el-option
                  v-for="item in attrLabelList"
                  :key="item.value"
                  :label="item.text"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <div class="select_box">
              <el-select
                v-model="formData.ams_shop_commodity_attr_value"
                placeholder="选择属性值"
                @focus="handleFocusGetAttrvalue"
                :loading="loadingAttrvalue"
              >
                <el-option
                  v-for="item in attrValueList"
                  :key="item.value"
                  :label="item.text"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <div class="block">
            <p><span class="mark">*</span>入库商品批次记录：</p>
            <div class="input_box">
              <el-input
                v-model="formData.makerno"
                placeholder="输入商品批次记录"
              ></el-input>
            </div>
          </div>

          <div class="block">
            <p><span class="mark">*</span>入库商品生产商：</p>
            <div class="select_box">
              <el-select
                v-model="formData.makername"
                placeholder="选择商品生产商"
                @focus="handleFocusGetSupplier"
                :loading="loadingSupplier"
              >
                <el-option
                  v-for="item in supplierList"
                  :key="item.id"
                  :label="item.labelname"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
        </div>
      </div>
      <div class="form_footer flex-rowl">
        <div class="btn" @click="handleSubmit">确认</div>
        <div class="return_txt" @click="handleReturn">←返回</div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getCommidityDetail,
  setShopWareParam,
  getWearhouseList,
  getProducerList,
  getLogistics,
  getAttrLabelList,
  getAttrLabelValue,
} from "../../api/api";
export default {
  name: "wManageSettingItem",
  data() {
    return {
      qyid: 0,
      nowDate: "",

      detail: "", // 商品详情

      isShow: false,
      columns: ["杭州", "宁波", "温州", "绍兴", "湖州", "嘉兴", "金华", "衢州"],
      // 记录类型
      actname: "",
      actnameList: [
        {
          text: "增加",
          value: "add",
        },
        {
          text: "减少",
          value: "reduce",
        },
      ],

      warehouseList: [],
      warehouseOne: [], // 仓库
      warehouseTwo: [], // 货架
      warehouseThree: [], // 层数
      warehouseFour: [], // 位置

      // 生产商
      supplierList: [],
      loadingSupplier: false,

      // 物流
      logisiticsList: [],
      loadingLog: false,

      // 属性标签
      attrLabelList: [],
      loadingAttrid: false,
      // 属性值
      attrValueList: [],
      loadingAttrvalue: false,

      keyword: "",
      loading: false,
      type: 1, // 1采购入库 2生产入库
      formData: {
        cmid: "",
        acttype: "",
        // realnum: '',  // 实际库存数
        // actname: '',  // 记录类型
        reason: "", // 备注
        whid1: "", // 仓库id
        whid2: "", // 货架id
        whid3: "", // 层位id
        whid4: "", // 货位id
        userman: "", // 登录的管理员名
        ams_shop_commodity_attrid: "",
        ams_shop_commodity_attr_value: "",
        purchaseno: "",
        wsid: "",
        wsogid: "",
        makerno: "",
        makername: "",
        wsno: "",
      },
    };
  },
  created() {
    let userInfo = this.$store.state.USERINFO;
    if (userInfo.qy) {
      this.qyid = userInfo.qy.id;
    } else {
      this.qyid = 0;
    }
    this.formData.userman = userInfo.truename;
    let { cmid, type, keyword } = this.$route.params;
    this.keyword = keyword;
    this.formData.cmid = cmid;
    this.formData.wsogid = cmid;
    this.formData.acttype = type;
    this.getInit();
  },
  methods: {
    async getInit() {
      await this.getDetail();
      await this.getWarehouse();
      // await this.getLogisitics();
      // await this.getAttrLabel();
    },

    // 获取商品详情
    getDetail() {
      let { cmid } = this.formData;
      getCommidityDetail({ id: cmid }).then((res) => {
        this.detail = res;
      });
    },
    // 获取仓库-货架-层号-位置
    getWarehouse() {
      getWearhouseList({ openid: this.$store.state.OPENID }).then((res) => {
        if (res.length > 0) {
          this.warehouseList = res;
          let newData = [];
          res.forEach((v) => {
            newData.push({
              value: v.id,
              text: v.whname,
              child: v.childs2,
            });
          });
          this.formData.whid2 = "";
          this.warehouseTwo = [];
          this.formData.whid3 = "";
          this.warehouseThree = [];
          this.formData.whid4 = "";
          this.warehouseFour = [];
          this.warehouseOne = newData;
        } else {
          this.warehouseList = "";
        }
      });
    },
    handleChangeWarehouseOne(e) {
      let { warehouseOne } = this;
      let newData = [];
      warehouseOne.forEach((v) => {
        if (v.value == e) {
          v.child.forEach((item) => {
            newData.push({
              value: item.id,
              text: item.whname,
              child: item.childs3,
            });
          });
        }
      });
      this.formData.whid2 = "";
      this.warehouseTwo = newData;
      this.formData.whid3 = "";
      this.warehouseThree = [];
      this.formData.whid4 = "";
      this.warehouseFour = [];
    },
    handleChangeWarehouseTwo(e) {
      let { warehouseTwo } = this;
      let newData = [];
      warehouseTwo.forEach((v) => {
        if (v.value == e) {
          v.child.forEach((item) => {
            newData.push({
              value: item.id,
              text: item.whname,
              child: item.childs4,
            });
          });
        }
      });
      this.formData.whid3 = "";
      this.warehouseThree = newData;
      this.formData.whid4 = "";
      this.warehouseFour = [];
    },
    handleChangeWarehouseThree(e) {
      let { warehouseThree } = this;
      let newData = [];
      warehouseThree.forEach((v) => {
        if (v.value == e) {
          v.child.forEach((item) => {
            newData.push({
              value: item.id,
              text: item.whname,
            });
          });
        }
      });
      this.formData.whid4 = "";
      this.warehouseFour = newData;
    },

    // 获取物流类型
    handleFocusGetLog() {
      this.loadingLog = true;
      getLogistics().then((res) => {
        this.logisiticsList = res;
        this.loadingLog = false;
      });
    },
    // 获取属性标签
    handleFocusGetAttrid() {
      this.loadingAttrid = true;
      getAttrLabelList().then((res) => {
        let newDate = [];
        res.forEach((v) => {
          if (v.attrstate == "启用") {
            newDate.push({
              value: v.id,
              text: v.attrname,
            });
          }
        });
        this.attrLabelList = newDate;
        this.loadingAttrid = false;
      });
    },
    // 获取属性值
    handleFocusGetAttrvalue() {
      let { ams_shop_commodity_attrid, cmid } = this.formData;
      this.loadingAttrvalue = true;
      getAttrLabelValue({ cmid, attrid: ams_shop_commodity_attrid }).then(
        (res) => {
          let newDate = [];
          res.forEach((v) => {
            if (v.isuse) {
              newDate.push({
                value: v.id,
                text: v.attrvalue,
              });
            }
          });
          this.attrValueList = newDate;
          this.loadingAttrvalue = false;
        }
      );
    },
    // 获取生产商
    handleFocusGetSupplier() {
      let { qyid } = this;
      this.loadingSupplier = true;
      getProducerList({ qyid, Page: 1, PageSize: 100 }).then((res) => {
        this.supplierList = res;
        this.loadingSupplier = false;
      });
    },

    handleReturn() {
      history.back();
    },

    handleSubmit() {
      let { formData } = this;
      if (formData.num == "") {
        this.$message.warning("请输入入库数量");
        return;
      }
      if (formData.purchaseno == "") {
        this.$message.warning("请输入入库订单信息");
        return;
      }
      if (formData.wsno == "") {
        this.$message.warning("请输入入库收货物流单号");
        return;
      }
      let time = new Date();
      let year = time.getFullYear();
      let month = time.getMonth() + 1;
      let date = time.getDate();
      let h = time.getHours();
      let m = time.getMinutes();
      let s = time.getSeconds();
      this.nowDate =
        year + "-" + month + "-" + date + " " + h + ":" + m + ":" + s;

      this.loading = true;
      setShopWareParam(formData).then((res) => {
        if (res.result) {
          this.loading = false;
          let message = this.$message.success(res.message);
          setTimeout(() => {
            message.close();
            history.back();
          }, 1500);
        } else {
          this.loading = false;
          this.$message.error(res.message);
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.warehousingPage {
}
</style>